<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1"><span><i>In particular,<br/>for Susan and Justine.<br/>In general, for all those<br/>who will not be<br/>comforted</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6a4120a2